import { Alert } from "@platform/design-system";
import { JSX, PropsWithChildren } from "react";

import { submitEvent } from "../utils/tracking";

type Props = PropsWithChildren<{
  onClose?: VoidFunction;
}>;

function AlertError({ children, onClose }: Props): JSX.Element {
  submitEvent("Error Viewed", {
    error_type: "alert",
    error_reason: children,
  });
  return (
    <Alert severity="error" onClose={onClose}>
      {children}
    </Alert>
  );
}

export default AlertError;
